import React from "react";
import { FunctionField, ShowProps, TextField } from "react-admin";
import {
  Button,
  Grid,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { GridinRowsWithSpace } from "utils/style";
import CustomDateField from "components/CustomDateField";
import { Link } from "react-router-dom";
import EditIcon from "@material-ui/icons/Edit";
import { availableOnlySuperAdminAndAdminAndFinance } from "utils/tools";
import StatusField from "../../components/StatusField";
import CustomLabeled from "../../components/layout/CustomLabeled";

const useStyles = makeStyles({
  summaryButton: {
    position: "relative",
    top: 20,
  },
  table: {
    minWidth: 650,
  },
});

const Summary = (props: ShowProps) => {
  const classes = useStyles();

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12} style={GridinRowsWithSpace}>
          <Typography variant="h6">Person In Charge Detail</Typography>

          {availableOnlySuperAdminAndAdminAndFinance() && (
            <Button
              className={classes.summaryButton}
              variant="contained"
              color="primary"
              component={Link}
              to={{
                pathname: `/personInCharges/${Number(props.id)}`,
              }}
              startIcon={<EditIcon />}
            >
              Edit
            </Button>
          )}
        </Grid>

        <Grid item xs={12}>
          <CustomLabeled name="Id">
            <TextField source="id" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={12}>
          <CustomLabeled name="Name">
            <FunctionField
              render={(record: any) =>
                `${record.salutation}. ${record.firstName} ${record.lastName}`
              }
            />
          </CustomLabeled>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Email">
            <TextField source="user.email" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Mobile">
            <TextField source="mobile" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Status">
            <StatusField source="status" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Register Date">
            <CustomDateField source="createdAt" emptyText="-" isDateTime />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Security Code">
            <TextField source="securityCode" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={3}>
          <CustomLabeled name="Mbc Code">
            <TextField source="user.mbcCustomerId" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Billing Info
          </Typography>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Billing Name">
            <TextField source="billingAddress.name" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={12}>
          <CustomLabeled name="address">
            <TextField source="billingAddress.address" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Block No.">
            <TextField source="billingAddress.blockNumber" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Unit No.">
            <TextField source="billingAddress.unit" emptyText="-" />
          </CustomLabeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <CustomLabeled name="Building Name">
            <TextField source="billingAddress.building" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={3}>
          <CustomLabeled name="postalCode">
            <TextField source="billingAddress.postalCode" emptyText="-" />
          </CustomLabeled>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            Billing Emails
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <FunctionField
            label="Billing Email"
            render={(record: any) => (
              <>
                {record.billingEmails && (
                  <>
                    {record.billingEmails.length > 0 ? (
                      <TableContainer component={Paper}>
                        <Table
                          className={classes.table}
                          aria-label="simple table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>ID</TableCell>
                              <TableCell>Email</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {record.billingEmails.map((billingEmail: any) => (
                              <TableRow key={billingEmail.email}>
                                <TableCell component="th" scope="row">
                                  {billingEmail.id}
                                </TableCell>
                                <TableCell component="th" scope="row">
                                  {billingEmail.email}
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <Typography variant="body2">Record not Found.</Typography>
                    )}
                  </>
                )}
              </>
            )}
          />
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
